import { render, staticRenderFns } from "./custome-shortcut.vue?vue&type=template&id=21dcc9a8&scoped=true&"
import script from "./custome-shortcut.vue?vue&type=script&lang=ts&"
export * from "./custome-shortcut.vue?vue&type=script&lang=ts&"
import style0 from "./custome-shortcut.vue?vue&type=style&index=0&id=21dcc9a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dcc9a8",
  null
  
)

export default component.exports